export const tryAwait = async <T extends () => Promise<V>, V = void>(cb: T) => {
  try {
    await cb();
  } catch (e) {
    // ignore
  }
};
